<template>
  <gw-entity-filter-item :display-text="displayText" :property-name="propertyName"
    representation-field="nome" :search="finder"
      :selection-support="listing"
      :find-values="findValues">
    <template slot="item" slot-scope="{entity}">
      <div slot="item" slot-scope="{entity}">
        <b>Nome: </b>{{entity.nome}}<br/>
        <b>Tipo gestão: </b>{{entity.tipoGestao}}<br/>
        <b>Código A7: </b>{{entity.codigoA7}}
      </div>
    </template>
  </gw-entity-filter-item>
</template>

<script>
import { GwEntityFilterItem, GwCustomFilterItemMixin } from 'guaxinim-web'
import IndicadorRestResource from './IndicadorRestResource'
import A7IndicadorListing from './A7IndicadorListing'

export default {
  name: 'a7-indicador-filter-item',
  mixins: [GwCustomFilterItemMixin],
  components: {
    GwEntityFilterItem,
    GwCustomFilterItemMixin,
    A7IndicadorListing
  },
  data() {
    return {
      listing: A7IndicadorListing
    }
  },
  methods: {
    finder(pattern) {
      if (!pattern) return null
      return IndicadorRestResource.
        findIndicadorFinderDTO(pattern, 10)
    },
    findValues(ids) {
      return IndicadorRestResource.findEntities(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
